import { BlurView, BlurViewProps } from 'expo-blur'
import { StyleProp, ViewStyle } from 'react-native'
import Animated from 'react-native-reanimated'
import cn from '@ui/utils/cn'

interface Props {
  style?: StyleProp<ViewStyle>
  intensity?: BlurViewProps['intensity']
  tint?: BlurViewProps['tint']
  className?: string
  children?: React.ReactNode
}

export default function BlurEffect({
  style = {},
  intensity = 100,
  tint = 'dark',
  className,
  children,
}: Props) {
  return (
    <Animated.View
      className={cn('absolute bottom-0 w-full overflow-hidden', className)}
      style={style}
    >
      <BlurView intensity={intensity} tint={tint} className="h-full w-full" />
      {children}
    </Animated.View>
  )
}
